import { GUID } from "../../helpers/guid.helper";
import { IDivision } from "./i-division";
import { Student } from "../students/student";
import { Curriculum } from '../curricula/curriculum';

export class Division implements IDivision {
    Id: number;
    DivisionName: string;
    CourseYearId: number;
    SchoolYearId: number;
    ShiftId: number;
    CurriculumId: number;
    IsActive: boolean;    
    CourseYearName: string;

    constructor() {
        this.Id = -1;
        this.DivisionName = '';
        this.CourseYearId = -1;
        this.CurriculumId = -1;
        this.ShiftId = -1;
        this.SchoolYearId = -1;
        this.IsActive = true;
        this.CourseYearName = '';
    }
}


// WEBPACK FOOTER //
// ./src/app/main/models/divisions/division.ts